/** @format */

import { mediaQuery } from '@/theme/mediaQuery';
import styled from 'styled-components';
import { ShowOnDesktop } from '../ShowOnDesktop';
import { Link } from 'gatsby-plugin-intl';

export const Container = styled.nav<{
  $hidden?: boolean;
  $page: 'page' | 'booking' | 'req-info' | 'listing' | 'room' | 'home' | 'blog';
}>`
  --link-color: ${({ theme, $page }) =>
    $page === 'home' || $page === 'listing' || $page === 'booking'
      ? theme.colors.joivy.white
      : theme.colors.joivy['teal-dark']};
  --active-link-color: ${({ theme, $page }) =>
    $page === 'home' || $page === 'listing' || $page === 'booking'
      ? theme.colors.joivy.yellow
      : theme.colors.joivy.pink};
  --bg-color: ${({ theme, $page }) =>
    $page === 'home' || $page === 'listing' || $page === 'booking'
      ? theme.colors.joivy['teal-dark']
      : theme.colors.joivy.white};
  --content-block-padding: 1rem ${({ $page }) => ($page === 'listing' ? '1.5rem' : '1rem')};
  --content-inline-padding: ${({ $page }) => {
    switch ($page) {
      case 'listing':
        return '1rem';
      case 'room':
        return '0.75rem';
      default:
        return '25px';
    }
  }};

  & * {
    box-sizing: border-box;
  }
  overscroll-behavior-x: none;
  top: 0;
  position: ${({ $hidden }) => ($hidden ? 'relative' : 'sticky')};
  animation: ${({ $hidden }) => ($hidden ? 'none' : 'animate-navbar')} 0.3s ease-in-out;

  @keyframes animate-navbar {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  ${({ $page }) => {
    if ($page === 'room') return `position: relative; z-index: 5;`;
    if ($page === 'listing')
      return `
      z-index: 5;
    `;
    if ($page === 'blog')
      return `
      z-index: 22;
    `;
    return `
      z-index: 15;
    `;
  }}

  @media screen and (min-width: 1160px) {
    --content-inline-padding: ${({ $page }) => {
      switch ($page) {
        case 'listing':
          return 2.5;
        default:
          return 5;
      }
    }}rem;
  }
`;

export const Background = styled.div<{ $forceWhite?: boolean }>`
  background: ${({ $forceWhite, theme }) => ($forceWhite ? theme.colors.joivy.white : 'var(--bg-color)')};
`;

export const Content = styled.div<{ $listing?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  ${({ $listing }) => {
    if ($listing)
      return `
        padding: var(--content-block-padding);
      `;
    else
      return `
      padding-block: var(--content-block-padding);
      padding-inline: var(--content-inline-padding);

      @media screen and (min-width: 1160px) {
        max-width: 1440px;
        margin-inline: auto;
      }
    `;
  }}
`;

export const HorizontalPaddingContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 1.5rem 0 1.5rem;
`;

export const VerticalDivider = styled.div`
  width: 2px;
  height: 42px;
  background-color: ${({ theme }) => theme.colors.joivy['teal-dark-700']};
`;

export const LinksContainer = styled.ul<{ $listing?: boolean }>`
  ${({ $listing }) => {
    if ($listing)
      return `
      margin: 0;
    `;
  }}

  display: flex;
  justify-content: flex-end;
  align-items: center;

  gap: 2.25rem;
  list-style: none;

  a {
    color: var(--link-color);
    text-decoration: none;
    padding-block: 1rem;
    transition: all 0.3s ease-in-out;

    &:hover {
      color: var(--active-link-color);
    }
  }
`;

export const LeftContentWrapper = styled.div`
  display: flex;
  align-items: center;

  gap: 2rem;

  @media screen and (max-width: 460px) {
    gap: 1rem;
  }

  .mobile_listing_logo {
    @media screen and (min-width: 481px) {
      display: none;
    }
  }

  .dekstop_listing_logo {
    @media screen and (max-width: 480px) {
      display: none;
    }
  }
`;

export const FiltersContainerDesktop = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
  flex-basis: 100%;

  @media screen and (max-width: 1160px) {
    display: none;
  }
`;

export const FiltersContainerMobile = styled.div`
  flex-basis: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, auto));
  gap: 4px;
  padding-block: 1rem;

  .select-search {
    width: unset !important;
  }

  ${mediaQuery.lg`
    display: none;
  `}
`;

export const PagesContainerDesktop = styled(ShowOnDesktop)`
  flex-basis: 250px;
  flex-grow: 1;
  flex-shrink: 1;
`;

export const LoginLink = styled(Link)<{ mobile?: boolean }>`
  background-color: #ffe84c;
  border: 0.0625rem solid #ffe84c;
  border-radius: 0.5rem;
  padding: 0.5rem 0.875rem !important;

  span {
    color: #015962 !important;
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1.25rem;
  }

  ${({ mobile }) =>
    mobile &&
    `
    padding: 0.75rem 1.25rem !important;
    width: fit-content;
    text-decoration: none;
    margin-bottom: 2.5rem;

    span {
      line-height: 1.5rem;
      font-size: 1rem;
    }
  `}
`;
